<template>
  <div class="boxs">
    <div class="boxwrap">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row tooltip-effect="dark"
        style="width: 100%">
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column label="申请编号" align="center">
          <template slot-scope="scope">{{ scope.row.apply_number }}</template>
        </el-table-column>
        <el-table-column label="项目编号" align="center">
          <template slot-scope="scope">{{ scope.row.project_number }}</template>
        </el-table-column>
        <el-table-column label="委托单位" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_client_name
          }}</template>
        </el-table-column>
        <el-table-column label="产品型号" align="center">
          <template slot-scope="scope">{{ scope.row.product_model }}</template>
        </el-table-column>
        <el-table-column label="产品名称" align="center">
          <template slot-scope="scope">{{ scope.row.product_name }}</template>
        </el-table-column>
        <el-table-column label="文件名" align="center">
          <template slot-scope="scope">
            <!-- <a class="alink"
              :href='`https://iot.cn-cvin.com/adminapi/public/download-file?file_url=${scope.row.upload_url}&file_name=${scope.row.upload_name}`'>
              {{ scope.row.upload_name }}</a> -->
            <div class="look" @click="preview(scope.row)">
              {{ scope.row.upload_name }}
            </div>
            <!-- <el-button @click="shareBtn(scope.$index, scope.row)" size="small" type="primary">分享</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { httpGetpdf } from "../utils/login";
export default {

  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    let arr = [];
    if (this.$route.query.data) {
      arr.push(JSON.parse(this.$route.query.data));
      this.tableData = arr;
      console.log(this.tableData);
    }
  },
  methods: {
    toExcel(row){
      this.httpDownloadPdf(row)
    },

    httpDownloadPdf(row) {
      console.log(row.upload_name, '888888')
      console.log(row.upload_url, '8888889999')
      httpGetpdf({
        name: row.upload_name,
        url: row.upload_url,
      }, { responseType: "blob" },

      )
        .then((res) => {
           const blob = new Blob([res], {
            type: "application/pdf;charset-UTF-8",
          });
          const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName =  row.upload_name //保存到本地的文件名称
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            console.log(link);
            link.remove();

          // const blob = new Blob([res], {
          //   type: "application/pdf;charset-UTF-8",
          // });
          // // console.log(blob);
          // const fileName = row.upload_name;
          // if ("download" in document.createElement("a")) {
          //   // 非IE下载
          //   const elink = document.createElement("a");
          //   elink.download = fileName;
          //   elink.style.display = "none";
          //   elink.href = URL.createObjectURL(blob);
          //   document.body.appendChild(elink);
          //   elink.click();
          //   URL.revokeObjectURL(elink.href); // 释放URL 对象
          //   document.body.removeChild(elink);
          // } else {
          //   // IE10+下载
          //   // navigator.msSaveBlob(blob, fileName);
          //   navigator.msSaveBlob(blob);
          // }
          
         })
        .catch((res) => {
          const blob = new Blob([res], {
            type: "application/pdf;charset-UTF-8",
          });
          // console.log(blob);
          const fileName = row.upload_name;
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            // navigator.msSaveBlob(blob, fileName);
            navigator.msSaveBlob(blob);
          }
        });
    },
    // toExcel() {
    //   this.$http
    //     .post(
    //       "adminapi/storage/warehouse/list",
    //       {
    //         upload_name: row.upload_name,
    //         upload_url: row.upload_url,
    //       },
    //       { responseType: "blob" }
    //     )
    //     .then((res) => {
    //       this.$message({
    //         type: "success",
    //         message: "导出成功",
    //       });
    //     })
    //     .catch((res) => {
    //       const blob = new Blob([res], {
    //         type: "application/vnd.ms-excel",
    //       });
    //       const fileName = "仓库数据.xls";
    //       if ("download" in document.createElement("a")) {
    //         // 非IE下载
    //         const elink = document.createElement("a");
    //         elink.download = fileName;
    //         elink.style.display = "none";
    //         elink.href = URL.createObjectURL(blob);
    //         document.body.appendChild(elink);
    //         elink.click();
    //         URL.revokeObjectURL(elink.href); // 释放URL 对象
    //         document.body.removeChild(elink);
    //       } else {
    //         // IE10+下载
    //         navigator.msSaveBlob(blob, fileName);
    //         // navigator.msSaveBlob(blob);
    //       }
    //     });
    // },
    // shareBtn(index, item) {
    //   console.log(item.upload_url, '路径')
    //   // this.getShareInfo(item.upload_url)
    //   this.url = item
    //   let imgurl = this.tableData[index].upload_url
    //   var broser = window.navigator.userAgent.toLowerCase();
    //   if (broser.match(/MicroMessenger/i) == 'micromessenger') {
    //     console.log('微信浏览器');
    //     wx.ready(function () {
    //       wx.onMenuShareTimeline({
    //         title: '测试标题',
    //         desc: '测试描述',
    //         link: imgurl,
    //         imgUrl: '',
    //         success: function () {
    //           alert('分享成功')
    //           // 设置成功
    //         }
    //       })
    //       wx.onMenuShareAppMessage({
    //         title: '测试标题',
    //         desc: '测试描述',
    //         link: imgurl,
    //         imgUrl: '',
    //         success: function () {
    //           alert('分享成功')
    //           // 设置成功
    //         }
    //       })
    //     });
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: '请使用微信浏览器打开',
    //     });
    //   }
    // },
    // 微信分享接口
    // getShareInfo(url) {
    //   httpGetshare({
    //     url: url
    //   }).then((res) => {
    //     console.log(res)
    //     if (res.data.code == 0) {
    //       const wxConfig = res.data.data
    //       console.log(wxConfig)
    //       wx.config({
    //         beta: true,
    //         debug: true,
    //         appId: wxConfig.appId,
    //         timestamp: wxConfig.timestamp,
    //         nonceStr: wxConfig.noncestr,
    //         signature: wxConfig.signature,
    //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2  
    //       });
    //       wx.ready(() => {
    //         var shareData = {
    //           link: 'https://www.baidu.com/',
    //         };
    //         //点击要去分享
    //         // wx.updateAppMessageShareData(shareData);
    //         // wx.updateTimelineShareData(shareData);

    //         wx.onMenuShareTimeline(shareData);
    //         wx.onMenuShareAppMessage(shareData);
    //       });
    //     } else {
    //       this.$message({
    //         type: "error",
    //         message: res.data.msg,
    //       });
    //     }
    //   });
    // },

    //预览word，pdf
    preview(row) {
      console.log(row, "oc");
      if (row.url_oc == "pdf") {
        window.open(row.upload_url, "_blank");
      } else {
        window.open(
          "http://view.officeapps.live.com/op/view.aspx?src=" + row.upload_url,
          "_blank"
        );
      }
    },
  },
};
</script>

<style>
.alink {
  color: #62b3ff !important;
}

.look {
  color: #62b3ff;
  cursor: pointer;
  margin: 0 5px;
}

.boxs {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgb(255, 255, 255);
}

.boxwrap {
  width: 90%;
  margin-left: 5%;
  position: absolute;
  top: 50px;
}
</style>